export default "__VITE_ASSET__05107f45__"